import { put, takeLatest, all, call } from 'redux-saga/effects';
import { SearchActions, returnSearchResults, returnRedirect, clearRedirect } from '../actions/search.actions';
import { appEngineConfig, dmsConfig } from '../config/env';
import queryString from 'query-string';

function* performSearchSaga(action) {
    const term = action.payload.term;
    const token = action.payload.token;
    const results = yield all({
        cmsResults: call(cmsSearch, ...[term, token]),
        dmsResults: call(dmsSearch, term),
        dmsAttachResults: call(dmsAttachSearch, term)
    });
    yield put(returnSearchResults(results));
}

const cmsSearch = (term, token) => {
    const query = queryString.stringify({ query: term });
    let results = fetch(appEngineConfig.url + '/?' + query, {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + token,
            'access-control-allow-origin': '*',
            'Content-Type': 'application/json'
        }
    })
        .then(res => res.json())
        .catch(err => []);

    return results;
};


const dmsSearch = term => {
    const results = fetch(dmsConfig.documentSearchUrl + '/' + encodeURIComponent(term), {
        method: 'GET',
        credentials: 'include',
        redirect: 'follow',
        mode: 'cors',
        headers: {
            'access-control-allow-origin': '*',
            'Content-Type': 'application/json'
        }
    })
        .then(response => response.json())
        .then(json => parseDmsData(json))
        .catch(err => []);

    return results;
};

const parseDmsData = values => {
    let arr = [];
    for (let i = 0; i < values.length; i++) {
        let split = values[i].label.split('|||');
        arr.push({
            id: split[3],
            title: split[2],
            dms: split[0],
            instance: split[1]
        });
    }

    return arr;
};

const dmsAttachSearch = term => {
    const results = fetch(dmsConfig.attachmentSearchUrl, {
        method: 'POST',
        credentials: 'include',
        redirect: 'follow',
        mode: 'cors',
        headers: {
            'access-control-allow-origin': '*',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ searchTerm: term })
    })
        .then(res => {
            return res.json()
        })
        .then(resData => {
            return resData[Object.keys(resData)[0]]
        })
        .catch(err => []);

    return results;
};

function* getRedirectSaga(action) {
    const item = action.payload.item;
    const isAttachment = action.payload.isAttachment;
    const docData = yield fetch(dmsConfig.redirectUrl + '/' + item.id + '/' + item.dms + '/' + item.instance, {
        method: 'GET',
        credentials: 'include',
        redirect: 'follow',
        mode: 'cors',
        headers: {
            'access-control-allow-origin': '*',
            'Content-Type': 'application/json'
        }
    })
        .then(res => res.json())
        .catch(err => null);

    let url = null;
    if (docData !== null) {
        if (!isAttachment) {
            url = docData.url;
        } else {
            let split = docData.primaryAttachment.split('|||');
            url = split[2];
        }
    }

    yield put(returnRedirect(url));
    yield put(clearRedirect());
}

export function* searchSaga() {
    yield takeLatest(SearchActions.PERFORM_SEARCH, performSearchSaga);
    yield takeLatest(SearchActions.GET_REDIRECT, getRedirectSaga);
}
